<template>
  <div
    class="bm-floating-nav bm-side-nav-shell top-20 bottom-5 left-4 md:left-6 hidden sm:flex flex-col transition-all duration-300"
    :class="uiStore.sideNavOpen ? 'w-16 md:w-56' : 'w-16 md:w-16'"
  >
    <div
      class="bm-glass bm-sideglass flex-1 flex flex-col py-4 px-2 md:px-3 gap-1"
      :class="uiStore.sideNavOpen ? 'bm-sideglass--open' : 'bm-sideglass--collapsed'"
    >
      <button
        type="button"
        class="bm-side-link bm-side-toggle flex items-center gap-3 rounded-2xl px-3 py-2 mx-1 mb-2 no-underline transition-all"
        :aria-label="uiStore.sideNavOpen ? 'Collapse navigation' : 'Expand navigation'"
        @click="uiStore.toggleSideNav"
      >
        <v-icon class="bm-side-icon" :icon="uiStore.sideNavOpen ? 'mdi-chevron-left' : 'mdi-chevron-right'" size="19" />
        <span v-if="uiStore.sideNavOpen" class="hidden md:inline text-sm">Collapse</span>
      </button>
      <router-link
        v-for="item in items"
        :key="item.to"
        v-slot="{ isActive, navigate, href }"
        :to="item.to"
        custom
      >
        <a
          :href="href"
          class="bm-side-link flex items-center gap-3 rounded-2xl px-3 py-2 mx-1 no-underline transition-all"
          :class="isActive ? 'bm-side-link-active font-medium' : 'hover:bg-[rgba(255,255,255,0.12)]'"
          @click="navigate"
        >
          <v-icon class="bm-side-icon" :icon="item.icon" size="19" />
          <span v-if="uiStore.sideNavOpen" class="hidden md:inline text-sm">{{ item.label }}</span>
        </a>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useUiStore } from '../../store/ui';

const uiStore = useUiStore();

const items = computed(() => [
  { to: '/browse', icon: 'mdi-view-grid-outline', label: 'Browse' },
  { to: '/listings/new', icon: 'mdi-plus-circle-outline', label: 'New Listing' },
  { to: '/listings/mine', icon: 'mdi-format-list-bulleted', label: 'My Listings' },
  { to: '/offers', icon: 'mdi-swap-horizontal', label: 'Offers' },
]);
</script>

<style scoped>
.bm-side-nav-shell {
  min-width: 0;
}

.bm-sideglass {
  min-width: 0;
  overflow: hidden;
  border-radius: 12px;
  background: rgba(221, 216, 203, 0.88);
}

.theme--dark .bm-sideglass {
  background: rgba(20, 34, 29, 0.74);
}

.bm-sideglass--collapsed {
  align-items: center;
}

.bm-side-link {
  color: rgba(47, 58, 49, 0.92);
  min-height: 42px;
  width: 100%;
  min-width: 0;
  flex: 0 0 auto;
  border-radius: 14px !important;
  overflow: hidden;
}

.theme--dark .bm-side-link {
  color: var(--bm-ink-soft);
}

.bm-side-toggle {
  border: 0;
  text-align: left;
}

.bm-sideglass--collapsed .bm-side-link {
  width: 44px;
  height: 44px;
  min-height: 44px;
  justify-content: center;
  padding: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.bm-sideglass--open .bm-side-link {
  justify-content: flex-start;
  width: calc(100% - 0.5rem);
}

.bm-side-icon {
  display: grid;
  place-items: center;
  width: 28px;
  min-width: 28px;
  height: 28px;
  border-radius: 12px;
  font-size: 19px;
  background: rgba(78, 98, 79, 0.16);
}

.theme--dark .bm-side-icon {
  background: rgba(111, 128, 108, 0.12);
}

.bm-side-link-active {
  color: var(--bm-text-strong);
  background: linear-gradient(135deg, rgba(141, 200, 232, 0.28), rgba(167, 200, 162, 0.24));
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.26), 0 12px 26px rgba(42, 59, 41, 0.14);
}

.theme--dark .bm-side-link-active {
  color: rgba(247, 242, 232, 0.96);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.14), 0 12px 26px rgba(3, 10, 8, 0.22);
}
</style>
